const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Debug {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'debugExt', name: '🐛 デバッグ', color1: '#FF9800', color2: '#F57C00',
            blocks: [
                { opcode: 'log', blockType: BlockType.COMMAND, text: 'コンソールに [T] を出力', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'debug' } } },
                { opcode: 'warn', blockType: BlockType.COMMAND, text: '警告 [T]', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'warning' } } },
                { opcode: 'error', blockType: BlockType.COMMAND, text: 'エラー [T]', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'error' } } },
                { opcode: 'breakpoint', blockType: BlockType.COMMAND, text: 'ブレークポイント' },
                { opcode: 'clear', blockType: BlockType.COMMAND, text: 'コンソールをクリア' }
            ]
        };
    }
    log(args) { console.log(Cast.toString(args.T)); }
    warn(args) { console.warn(Cast.toString(args.T)); }
    error(args) { console.error(Cast.toString(args.T)); }
    breakpoint() { debugger; }
    clear() { console.clear(); }
}
module.exports = Scratch3Debug;